import apiRequest from './apiRequest';

export default async function postSceneObjectMotionEditApply(
  sceneID: string,
  referenceName: string,
  timelineIndex: number,
  jobID: string,
  apiKey: string,
  signal?: AbortSignal,
) {
  return apiRequest<void>(
    'external-mogen',
    `/scenes/${encodeURIComponent(sceneID)}/objects/${encodeURIComponent(referenceName)}/${timelineIndex}/motionEdits/${encodeURIComponent(jobID)}/apply`,
    {
      method: 'POST',
      headers: {
        'x-api-key': apiKey,
      },
    },
    signal,
  );
}
